<div class="script-details card" *ngIf="script">
  <!-- Header row -->
  <div class="header-row">
    <div class="title-section">
      <h3 class="script-title">{{ script.name }}</h3>
      <p-tag
        [value]="script.enabled ? 'Enabled' : 'Disabled'"
        [severity]="script.enabled ? 'success' : 'secondary'"
      ></p-tag>
    </div>
    <div class="actions-row">
      <button
        pButton
        icon="pi pi-pencil"
        label="Edit"
        class="p-button-sm p-button-text"
        *hasPermission="['scripts.update']"
        (click)="openUpdate()"
      ></button>
      <button
        pButton
        icon="pi pi-book"
        label="History"
        class="p-button-sm p-button-text p-button-secondary"
        (click)="viewHistoryAction.command()"
      ></button>
    </div>
  </div>

  <!-- Source info -->
  <div class="detail-section" *ngIf="getSourceType() === 'url'">
    <label>Source URL</label>
    <div class="source-url">
      <a [href]="script.scriptUrl" target="_blank" rel="noopener">
        {{ script.scriptUrl }}
        <i class="pi pi-external-link"></i>
      </a>
    </div>
  </div>

  <div class="detail-section" *ngIf="getSourceType() === 'inline'">
    <label>Inline Code</label>
    <pre class="code-preview">{{ getSourcePreview() }}</pre>
  </div>

  <!-- Description -->
  <div class="detail-section" *ngIf="script.description">
    <label>Description</label>
    <p class="description-text">{{ script.description }}</p>
  </div>

  <!-- Hooks -->
  <div class="detail-section">
    <label>Hooks</label>
    <div class="hooks-list">
      <p-tag
        *ngFor="let hook of script.hooks"
        [value]="hook"
        severity="info"
      ></p-tag>
      <span *ngIf="!script.hooks?.length" class="text-secondary">None</span>
    </div>
  </div>
</div>

<app-mutate-script #mutate></app-mutate-script>